
import { addParamsToUrl, formatStringValue } from "ice.fo.utils/StringUtils";
export default {
  props: {
    instanceId: {
      type: [String, Number],
      default: null,
    },
    url: {
      type: [String, Object, Array],
      default: "",
    },
    target: {
      type: String,
      default: "_self",
    },
    title: {
      type: String,
      default: "",
    },
    keepQuery: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    link() {
      if (!this.url) {
        return "";
      }

      let linkResult = "";
      if (Array.isArray(this.url)) {
        linkResult = this.$getPageUrl(
          addParamsToUrl(
            formatStringValue(this.url[1], this.url[0] || ""),
            this.keepQuery ? this.$route.query : this.url[2] || {}
          )
        );
      } else {
        linkResult = addParamsToUrl(
          this.$getPageUrl(this.$getValue(this.url)),
          this.keepQuery ? this.$route.query : {}
        );
      }

      if (this.instanceId) {
        linkResult = addParamsToUrl(linkResult, { _iref: this.instanceId });
      }

      return linkResult;
    },
    tag() {
      return this.$isExternalUrl(this.link) ? "a" : "nuxt-link";
    },
    computedTitle() {
      return this.title || this.$t("meta.site");
    },
    attributes() {
      if (this.$isExternalUrl(this.link)) {
        return {
          href: this.link || "",
          target: this.target,
          title: this.computedTitle,
        };
      } else {
        return {
          to: this.link || this.$route.path,
          target: this.target,
          title: this.computedTitle,
        };
      }
    },
  },
};
